module.exports = __webpack_public_path__ + "img/1.7b2f604c.jpg";